// src/screens/student/aistudyassistant/AIStudyAssistant.js
import React, { useState, useRef, useEffect, useContext } from 'react';
import '../../../assets/css/student/aistudyassistant/AIStudyAssistant.css';
import StudentLayout from '../../../layouts/student/studentlayout/StudentLayout';
import { Button, Col, Row } from 'react-bootstrap';
import { IoIosFlash } from "react-icons/io";
import axios from 'axios';
import AppContext from '../../../context/AppContext';


const AIStudyAssistant = () => {
  const {baseUrl,loggedInStudent,
storeLoggedInStudent} = useContext(AppContext); 
  const [messages, setMessages] = useState([]); 
  const [conversations, setConversations] = useState([]); 
  const [inputMessage, setInputMessage] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [selectedFeature, setSelectedFeature] = useState(null);
  const [isNewConversation, setIsNewConversation] = useState("no");
  const [selectedConversationId, setSelectedConversationId] = useState();
  const messagesEndRef = useRef(null);


  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };


  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  



  const handleFeatureClick = (conversation) => {
    console.log(conversation.id);
    setIsNewConversation("no");
    setSelectedConversationId(conversation.id);
    setSelectedFeature(conversation);
    viewAllMessages(conversation.id);
  };



  const ilamAiCall = () => {
    const formData = new FormData();
    formData.append("isNewConversation", isNewConversation);
    formData.append("message", inputMessage);
    formData.append("chstudent_id", loggedInStudent.id);
    formData.append("con_for", "assistant");
    formData.append("chsubject_id", 0);
    formData.append("conversation_id", selectedConversationId);
    
    axios
      .post(`${baseUrl}/student/ilamai/ilamcall`, formData, {
        headers: {
          "Content-Type": "multipart-formdata",
        },
      })
      .then((response) => {
        console.log(response.data);
        setInputMessage("");
        viewAllMessages(selectedConversationId);
        // setIsTyping(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  
  const viewAllMessages = (conversationId) => {
    const formData = new FormData();
    formData.append("chconversation_id",conversationId);
    axios
      .post(`${baseUrl}/student/ilamai/viewAllMessages`,formData,{
         headers: {
          "Content-Type": "multipart-formdata",
        },
      })
      .then((response) => {
        console.log(response.data);
        setMessages(response.data.chats);
        // setIsTyping(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const viewAllConversations = () => {
    const formData = new FormData();
    formData.append("chstudent_id",1);
    axios
      .post(`${baseUrl}/student/ilamai/viewAllConversations`,formData,{
         headers: {
          "Content-Type": "multipart-formdata",
        },
      })
      .then((response) => {
        console.log(response.data);
        setConversations(response.data.conversations);
        // setIsTyping(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  
  const createFlashCard = (chat_id) => {
    const formData = new FormData();
    formData.append("conversation_id", selectedConversationId);
    formData.append("chat_content", chat_id);
    axios
      .post(`${baseUrl}/student/ilamai/storeFlashCard`,formData,{
         headers: {
          "Content-Type": "multipart-formdata",
        },
      })
      .then((response) => {
        console.log(response.data);
        // setConversations(response.data.conversations);
        // setIsTyping(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  

  useEffect(()=>{
    storeLoggedInStudent(JSON.parse(localStorage.getItem('loggedInStudent')));
    viewAllConversations();
    // viewAllMessages();
  },[])


  return (
    <StudentLayout>
    <div className="ai-study-assistant">
     
      <div className="assistant-content">
        {/* Features Sidebar */}
        <div className="features-sidebar">
          <h3 className="sidebar-title">Features {'\t\t'} <span onClick={()=>{
            setMessages([]);
            setIsNewConversation("yes");

          }} className="btn btn-sm btn-primary" size='sm'>Create New Chat</span></h3>
          <div className="features-list">
            {conversations.map(conversation => (
              <div
                key={conversation.id}
                className={`feature-card ${selectedFeature?.id === conversation.id ? 'active' : ''}`}
                onClick={() => handleFeatureClick(conversation)}
              >
                <div className="feature-content">
                  <div className="feature-title">{conversation.title}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Chat Area */}
        <div className="chat-area">
          <div className="messages-container" style={{overflow:"scroll"}}>
            {messages.map((message,index) => (
              <div key={index} className={`message ai`}>
                <div className="message-avatar">
                  {message.type === 'ai' ? '🤖' : '👤'}
                </div>
                <div className="message-content">
                  <div className="message-header">
                    <span className="message-sender">
                      {message.type === 'ai' ? 'AI Assistant' : 'You'}
                    </span>
                  </div>
                  <div className="message-text">
                    <Row>
                      <Col sm={11}>
                          {message.content}                    
                      </Col>
                      <Col sm={1}>
                        <IoIosFlash size={30} color='#FFD700' onClick={()=>{
                          createFlashCard(message.content);
                        }} />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            ))}

            {isTyping && (
              <div className="message ai">
                <div className="message-avatar">🤖</div>
                <div className="message-content">
                  <div className="typing-indicator">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              </div>
            )}

            <div ref={messagesEndRef} />
          </div>

          {/* Input Area */}
          <div className="input-area">
            <div className="input-wrapper">
              <input
                type="text"
                placeholder="Ask me anything about your studies..."
                value={inputMessage}
                onChange={(e) => setInputMessage(e.target.value)}
                className="message-input"
              />
              <div className="input-actions">
                
                <button 
                  onClick={()=>{
                    ilamAiCall();
                  }}
                  className="send-btn"
                  disabled={!inputMessage.trim()}
                >
                  ➤
                </button>
              </div>
            </div>
            <div className="input-hint">
              💡 Try asking: "Summarize my notes", "Explain this concept", or "Create a quiz"
            </div>
          </div>
        </div>

       
      </div>
    </div>
    </StudentLayout>
  );
};

export default AIStudyAssistant;